import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getOAuthPath(locale: Locale): string {
	return getPathInLocale(locale, "/oauth");
}
